import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';

import { useCoaches } from '@/data/coach';

import CoachList from './components/list/CoachList';
import Search from './Search';

const ListPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Coaches
        </CardTitle>
        <CardDescription>List of all coaches.</CardDescription>
      </CardHeader>
      <CardContent>
        <Search />
        <CoachList />
      </CardContent>
    </Card>
  );
};

const ListPageLoader = () => {
  const coaches = useCoaches();

  if (coaches.isLoading && !coaches.data) {
    return <LoadingPage />;
  }

  return <ListPage />;
};

export default ListPageLoader;
